import { apiFactory } from "../api_factory";

export const woundRevisionsApi = apiFactory({
  path: `/api/v4/wound-revisions`
});
